module.exports = __webpack_public_path__ + "media/images/flags/64/Brazil-f7e89b9b1c84aa6d82e7f9fc4962ed89.png";